import React from 'react';
import { Box, Typography } from '@mui/material';
import Section from '../../../shared/Section/Section';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const PrecourseExpectations = ({ title, image, tallCard, details, images }) => {
  return (
    <Section title={title} theme="middlePurple" bg={'expectations'}>
      <Box
        sx={{
          display: {
            xl: 'block',
            xs: 'none',
          },
          position: 'absolute',
          right: {
            xl: '48px',
            lg: '25px',
            md: '20px',
          },
          top: { xl: tallCard ? 57 : 0, md: '-24px' },
          width: {
            md: '627px',
          },
          height: {
            md: '493px',
          },
        }}
      >
        <GatsbyImage
          image={getImage(images[`howBootcampWorks/${image}`])}
          alt="img"
        />
      </Box>
      <Box
        sx={{
          display: {
            lg: 'block',
            xs: 'none',
          },
          position: 'absolute',
          left: {
            lg: 0,
          },
          bottom: { xl: '-50px', lg: '70px' },
          width: {
            md: '586px',
          },
          height: {
            md: '586px',
          },
        }}
      ></Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: {
            md: 'row',
            xs: 'column',
          },
          gap: {
            md: '24px',
            xs: '12px',
          },
        }}
      >
        {details.map((card, idx) => (
          <ExpectationCard {...card} isTall={tallCard} key={`${idx}`} />
        ))}
      </Box>
    </Section>
  );
};

const ExpectationCard = ({ title, description, isVisible, Icon, isTall }) => {
  const visibilityProperty = isVisible ? 'visible' : 'hidden';
  return (
    <Box
      visibility={visibilityProperty}
      sx={{
        display: { xl: 'flex', xs: isVisible ? 'flex' : 'none' },
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '16px',
        borderRadius: '24px',
        backgroundColor: '#FFF',
        padding: {
          md: '24px',
          xs: '24px 16px 24px 16px',
        },
        width: {
          xl: '332px',
          md: '502px',
          xs: 'auto',
        },
        height: {
          xl: isTall ? '330px' : '271px',
          md: '243px',
          xs: 'auto',
        },
        zIndex: 1,
      }}
    >
      {Icon && <Icon sx={{ width: 56, height: 56 }} />}
      <Typography
        component={'h3'}
        variant="desktopH4"
        color="kit.text.h"
        sx={{
          lineHeight: {
            md: '130%',
          },
          letterSpacing: {
            md: '-1.54px',
          },
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="desktopP2"
        sx={{
          fontSize: {
            md: '16px',
          },
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default PrecourseExpectations;
